<template>
  <div style="width: 100%; display: flex; justify-content: center;">
    <div ref="gbutton" />
  </div>
</template>

<script>
export default {
  name: 'GoogleLoginButton',
  props: {
    clientId: {
      type: String,
      required: true
    }
  },
  mounted() {
    if (!window.google) {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    if (window.google && window.google.accounts?.id) {
      this.initGoogle();
    } else {
      const check = setInterval(() => {
        if (window.google && window.google.accounts?.id) {
          clearInterval(check);
          this.initGoogle();
        }
      }, 200);
    }
  },
  methods: {
    initGoogle() {
      try {
        window.google.accounts.id.initialize({
          client_id: this.clientId,
          callback: this.handleResponse
        });

        const parentWidth = this.$el.offsetWidth;

        window.google.accounts.id.renderButton(this.$refs.gbutton, {
          theme: 'outline',
          size: 'medium',
          width: parentWidth
        });
      } catch (err) {
        this.$emit('failure', err);
      }
    },

    handleResponse(response) {
      if (response?.credential) {
        this.$emit('success', response.credential);
      } else {
        this.$emit('failure', new Error('No credential returned'));
      }
    }
  }
};
</script>
